import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_URL, LIVE } from '../../common/variables';
const fetchSignUp = createAsyncThunk(
  'FETCHING_SINGUP',
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = arg;
      let res = await fetch(
        API_URL + '/users/register_by_email_with_merchant',
        {
          body: JSON.stringify({ ...data, live: LIVE }),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        },
      );
      if (res.status === 200) return await res.json();
      return rejectWithValue({ error: true, errorCode: res.status });
    } catch (e) {
      return rejectWithValue({ error: true, errorCode: 900 });
    }
  },
);

const signUpSlice = createSlice({
  name: 'signUp',
  initialState: {
    errorSignUp: false,
    isSingUp: false,
    success: null,
  },
  reducers: {},
  extraReducers: {
    [fetchSignUp.pending]: (state) => {
      state.isSingUn = true;
      state.errorSignUp = false;
      state.succes = null;
    },
    [fetchSignUp.fulfilled]: (state, action) => {
      state.isSingUn = false;
      state.errorSignUp = false;
      state.succes = true;
    },
    [fetchSignUp.rejected]: (state, action) => {
      state.isSingUn = false;
      state.errorSignUp = action.payload;
      state.succes = false;
    },
  },
});

//export const {} = citiesSlice.actions

export { fetchSignUp };

export default signUpSlice.reducer;
